import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFormatSection } from "src/models/Doc/Format.models";

interface FormatSectionState {
  formatSections: IFormatSection[];
  formatSectionToEdit: IFormatSection | null;
}

const initialState: FormatSectionState = {
  formatSections: [],
  formatSectionToEdit: null,
};

const FormatSectionSlice = createSlice({
  name: "Secciones",
  initialState,
  reducers: {
    setFormatSectionList: (state, action: PayloadAction<IFormatSection[]>) => {
      state.formatSections = action.payload;
    },
    concatListFormatSection: (
      state: FormatSectionState,
      action: PayloadAction<IFormatSection[]>
    ) => {
      state.formatSections = [...state.formatSections.concat(action.payload)];
    },
    setFormatSectionToEdit: (
      state,
      action: PayloadAction<IFormatSection | null>
    ) => {
      state.formatSectionToEdit = action.payload;
    },
    addFormatSection: (state, action: PayloadAction<IFormatSection>) => {
      state.formatSections.push(action.payload);
    },
    updateFormatSection: (state, action: PayloadAction<IFormatSection>) => {
      let itemIndex = state.formatSections.findIndex(
        item => item.formatDetailId === action.payload.formatDetailId
      );
      if (itemIndex !== -1) state.formatSections[itemIndex] = action.payload;
    },
    deleteFormatSection: (state, action: PayloadAction<number>) => {
      const newArray = state.formatSections.filter(
        item => item.formatDetailId !== action.payload
      );
      state.formatSections = newArray;
    },
  },
});

export const {
  setFormatSectionList,
  concatListFormatSection,
  setFormatSectionToEdit,
  addFormatSection,
  updateFormatSection,
  deleteFormatSection,
} = FormatSectionSlice.actions;

export default FormatSectionSlice.reducer;
